import { isJobActive } from "./provider-site";
import { SiteDetails } from "./site-details";
import { SiteLayout, SiteLoadingCard } from "./site-layout";
import { SiteStart } from "./site-start";
import { useMyProviderSite, useReadyDesigns } from "./site.hooks";
import { useJobPolling } from "./use-job-polling";

function SiteContent({ profileUuid, aiDesigner }: { profileUuid: string; aiDesigner: boolean }) {
  const { data, loading, startPolling, stopPolling } = useMyProviderSite(profileUuid);
  const site = data?.myProviderSite ?? null;
  // The gallery is a way in, not a condition: the page works while the library is unavailable.
  const { data: designsData } = useReadyDesigns(profileUuid);
  const designs = designsData?.readyDesigns.designs ?? [];

  useJobPolling(isJobActive(site?.activeJob), startPolling, stopPolling);

  if (loading && !data) {
    return <SiteLoadingCard />;
  }
  return site ? (
    <SiteDetails site={site} profileUuid={profileUuid} aiDesigner={aiDesigner} designs={designs} />
  ) : (
    <SiteStart aiDesigner={aiDesigner} designs={designs} />
  );
}

// "Мій сайт": the site's state and actions, or the ways to a first site.
export function SitePage() {
  return (
    <SiteLayout>
      {({ profileUuid, aiDesigner }) => (
        <SiteContent profileUuid={profileUuid} aiDesigner={aiDesigner} />
      )}
    </SiteLayout>
  );
}
